export enum CURRENCY {
    USD = 'USD',
    CAD = 'CAD',
    EUR = 'EUR',
    GBP = 'GBP',
    AUD = 'AUD',
    BTC = 'BTC'
}

export enum CURRENCY_SYMBOL {
    USD = '$',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    CAD = '$',
    EUR = '€',
    GBP = '£',
    BTC = '§',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    AUD = '$'
}

export const CURRENCY_TO_SYMBOL : { [currency in CURRENCY] : CURRENCY_SYMBOL } = {
    [ CURRENCY.USD ]: CURRENCY_SYMBOL.USD,
    [ CURRENCY.CAD ]: CURRENCY_SYMBOL.CAD,
    [ CURRENCY.EUR ]: CURRENCY_SYMBOL.EUR,
    [ CURRENCY.GBP ]: CURRENCY_SYMBOL.GBP,
    [ CURRENCY.BTC ]: CURRENCY_SYMBOL.BTC,
    [ CURRENCY.AUD ]: CURRENCY_SYMBOL.AUD
};

export enum INSTRUMENT_TYPE {
    CARD = 'card',
    PAYPAL = 'paypal',
    SHOPIFY = 'shopify',
    STRIPE = 'stripe'
}

export enum INSTRUMENT_SUBTYPE {
    ONETEXT_TOKEN = 'onetext_token',
    SPREEDLY_TOKEN = 'spreedly_token',
    PAYPAL_ORDER_ID = 'paypal_order_id',
    PAYPAL_VAULT_SETUP_TOKEN = 'paypal_vault_setup_token',
    SHOPIFY_INTENT = 'shopify_intent'
}

export const INSTRUMENT_LABEL = {
    [ INSTRUMENT_TYPE.CARD ]:    'card',
    [ INSTRUMENT_TYPE.PAYPAL ]:  'PayPal account',
    [ INSTRUMENT_TYPE.SHOPIFY ]: 'Shopify'
} as const;

export enum PAYMENT_PLATFORM {
    PAYPAL = 'paypal',
    STRIPE = 'stripe',
    OPENNODE = 'opennode',
    ONETEXT = 'onetext',
    AUTHORIZE_DOT_NET = 'authorize_dot_net',
    SHOPIFY = 'shopify',
    MAVERICK = 'maverick'
}

export type PaymentPlatform =
    | PAYMENT_PLATFORM.STRIPE
    | PAYMENT_PLATFORM.PAYPAL
    | PAYMENT_PLATFORM.AUTHORIZE_DOT_NET
    | PAYMENT_PLATFORM.MAVERICK;

export enum VAULT_PLATFORM {
    SPREEDLY = 'spreedly',
    PAYPAL = 'paypal'
}

export enum STORE_PLATFORM {
    SHOPIFY = 'shopify',
    WOO = 'woo'
}

export enum ORDER_STATUS {
    CREATED = 'created',
    COMPLETE = 'complete'
}

export enum ORDER_TYPE {
    PURCHASE = 'purchase',
    PAYMENT = 'payment'
}

export enum MARKETING_PLATFORM {
    ONETEXT = 'onetext',
    SHOPIFY = 'shopify',
    KLAVIYO = 'klaviyo',
    POSTSCRIPT = 'postscript',
    SENDLANE = 'sendlane',
    ATTENTIVE = 'attentive',
    OMNISEND = 'omnisend'
}

export enum MARKETING_LIST_TYPE {
    LIST = 'list',
    SEGMENT = 'segment'
}

export enum AUTHORIZATION_STATUS {
    CREATED = 'created',
    VOIDED = 'voided',
    CAPTURED = 'captured'
}

export enum CHARGE_STATUS {
    CREATED = 'created',
    PAID = 'paid',
    SETTLED = 'settled',
    PAYMENT_ERROR = 'payment_error',
    SETTLEMENT_ERROR = 'settlement_error'
}

export enum PAYMENT_AUTHORIZATION_ERROR {
    DUPLICATE = 'duplicate',
    CVV_CODE_INCORRECT = 'cvv_code_incorrect',
    BILLING_ADDRESS_INCORRECT = 'billing_address_incorrect',
    BILLING_POST_CODE_INCORRECT = 'billing_post_code_incorrect',
    INSUFFICIENT_FUNDS = 'insufficient_funds',
    CARD_NUMBER_INCORRECT = 'card_number_incorrect',
    CARD_EXPIRED = 'card_expired',
    TRANSACTION_NOT_ALLOWED = 'transaction_not_allowed',
    REQUIRES_ACTION = 'requires_action',
    ZERO_AMOUNT = 'zero_amount',
    INSTRUMENT_NOT_FOUND = 'instrument_not_found'
}

export enum PAYMENT_AUTHORIZATION_CAPTURE_ERROR {
    ALREADY_CAPTURED = 'already_captured'
}

export enum PAYMENT_AUTHORIZATION_REFUND_ERROR {
    REQUIRES_ADDITIONAL_TIME = 'requires_additional_time',
    DISPUTE = 'dispute',
    INSUFFICIENT_FUNDS = 'insufficient_funds',
    TIME_LIMIT_EXCEEDED = 'time_limit_exceeded',
    MERCHANT_CAN_NOT_ACCEPT_REFUND = 'merchant_can_not_accept_refund',
    ALREADY_REFUNDED = 'already_refunded',
    RISK_ERROR = 'risk_error',
    REFUND_NOT_ALLOWED = 'refund_not_allowed',
    CARD_EXPIRED = 'card_expired'
}

export enum SUBSCRIPTION_STATUS {
    INITIATED = 'initiated',
    ACTIVE = 'active',
    CANCELED = 'canceled'
}

export enum DISCOUNT_TYPE {
    PERCENTAGE = 'percentage',
    AMOUNT = 'amount',
    CODE = 'code'
}

export enum DISCOUNT_SUBTYPE {
    PRICE_REDUCTION = 'price_reduction',
    PRODUCT_MARKDOWN = 'product_markdown',
    CASHBACK = 'cashback',
    LOYALTY = 'loyalty'
}

export enum DISCOUNT_SOURCE {
    EXISTING_DISCOUNT = 'existing_discount',
    SHOPPING_SESSION_DISCOUNT = 'shopping_session_discount',
    PROFILE_RECOVERY_DISCOUNT = 'profile_recovery_discount',
    PURCHASE_OFFER_MINIMUM_DISCOUNT = 'purchase_offer_minimum_discount',
    PRODUCT_CHOICE_MINIMUM_DISCOUNT = 'product_choice_minimum_discount'
}

export enum CARD_VENDOR {
    VISA = 'visa',
    MASTERCARD = 'mastercard',
    AMEX = 'amex',
    DISCOVER = 'discover',
    DINERS = 'diners',
    JCB = 'jcb',
    UNKNOWN = 'unknown'
}

export enum SPREEDLY_CARD_VENDOR {
    VISA = 'visa',
    MASTERCARD = 'master',
    AMEX = 'american_express',
    DISCOVER = 'discover',
    DINERS = 'diners_club',
    JCB = 'jcb',
    UNKNOWN = 'unknown'

}

export const SPREEDLY_CARD_VENDOR_TO_CARD_VENDOR : { [key in SPREEDLY_CARD_VENDOR] : CARD_VENDOR } = {
    [SPREEDLY_CARD_VENDOR.VISA]:       CARD_VENDOR.VISA,
    [SPREEDLY_CARD_VENDOR.MASTERCARD]: CARD_VENDOR.MASTERCARD,
    [SPREEDLY_CARD_VENDOR.AMEX]:       CARD_VENDOR.AMEX,
    [SPREEDLY_CARD_VENDOR.DISCOVER]:   CARD_VENDOR.DISCOVER,
    [SPREEDLY_CARD_VENDOR.DINERS]:     CARD_VENDOR.DINERS,
    [SPREEDLY_CARD_VENDOR.JCB]:        CARD_VENDOR.JCB,
    [SPREEDLY_CARD_VENDOR.UNKNOWN]:    CARD_VENDOR.UNKNOWN
};

export const CARD_VENDOR_TO_SPREEDLY_CARD_VENDOR : { [key in CARD_VENDOR] : SPREEDLY_CARD_VENDOR } = {
    [CARD_VENDOR.VISA]:       SPREEDLY_CARD_VENDOR.VISA,
    [CARD_VENDOR.MASTERCARD]: SPREEDLY_CARD_VENDOR.MASTERCARD,
    [CARD_VENDOR.AMEX]:       SPREEDLY_CARD_VENDOR.AMEX,
    [CARD_VENDOR.DISCOVER]:   SPREEDLY_CARD_VENDOR.DISCOVER,
    [CARD_VENDOR.DINERS]:     SPREEDLY_CARD_VENDOR.DINERS,
    [CARD_VENDOR.JCB]:        SPREEDLY_CARD_VENDOR.JCB,
    [CARD_VENDOR.UNKNOWN]:    SPREEDLY_CARD_VENDOR.UNKNOWN
};

export const VAULT_PLATFORM_LABEL = {
    [ VAULT_PLATFORM.PAYPAL ]: 'PayPal'
} as const;

export const CARD_VENDOR_LABEL : {
    [CardVendor in CARD_VENDOR] : string
} = {
    [CARD_VENDOR.VISA]:       'Visa',
    [CARD_VENDOR.MASTERCARD]: 'Mastercard',
    [CARD_VENDOR.AMEX]:       'Amex',
    [CARD_VENDOR.DISCOVER]:   'Discover',
    [CARD_VENDOR.DINERS]:     'Diners Club',
    [CARD_VENDOR.JCB]:        'JCB',
    [CARD_VENDOR.UNKNOWN]:    'Unknown'
};

export enum CREDIT_TYPE {
    CUSTOMER_CARD_CHARGE_FEE = 'customer_card_charge',
    CUSTOMER_CARD_CHARGE_INTERNAL = 'customer_card_charge_internal',
    CUSTOMER_CARD_CHARGE_PROCESSOR_FEE_SURCHARGE = 'customer_card_charge_processor_fee_surcharge',
    DISPUTE_REVERSAL = 'dispute_reversal',
    MANUAL = 'manual',
    MERCHANT_CARD_CHARGE = 'merchant_card_charge',
    PAYOUT = 'payout',
    EXTERNAL_PAYMENT = 'external_payment',
    INCENTIVE = 'incentive',
    CORRECTION = 'correction'
}

export enum CVV_STATUS_CODE {
    MATCHES = 'M',
    DOES_NOT_MATCH = 'N',
    NOT_VERIFIED = 'U',
    NOT_PROVIDED = 'I',
    NOT_APPLICABLE = 'A',
    SKIPPED = 'B',
    NO_RESPONSE = 'X'
}

export enum AVS_STATUS_CODE {
    MATCHES = 'M',
    DOES_NOT_MATCH = 'N',
    NOT_VERIFIED = 'U',
    NOT_PROVIDED = 'I',
    NOT_APPLICABLE = 'A',
    SKIPPED = 'B',
    ISSUER_DOES_NOT_PARTICIPATE = 'S',
    SYSTEM_ERROR = 'E'
}
